﻿﻿export interface IDashRegistrationRequest {
    centerId: number;
    firstName: string;
    lastName: string;
    email: string;
    registrationDate: string;
}
